// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1ylrQ","label":"Completed_label__zsxyy"};